import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'rt-time-zone-picker-dropdown',
  templateUrl: 'time-zone-picker-dropdown.component.html',
  styleUrls: ['./time-zone-picker-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeZonePickerDropdownComponent {
  @Output() public close: EventEmitter<void> = new EventEmitter();
  @Output() public zoneSelect: EventEmitter<string> = new EventEmitter();
}
